

import { X } from "lucide-react";
import { KeywordPillProps } from "./types";

const KeywordPill = ({ text, onRemove }: KeywordPillProps) => (
  <div className="flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-700 rounded-full text-sm">
    {text}
    <button
      onClick={onRemove}
      className="hover:text-blue-900"
    >
      <X className="w-3 h-3" />
    </button>
  </div>
);

export default KeywordPill